import { GlobalStatus } from "@gtpl/shared-models/common-models";
import { SaleOrderDropDownDto } from "../sale-order-drop-down.dto";

export class SaleOrder {
    soInspectionId: number;
    inspectionName: string;
    isChecked: GlobalStatus;
    saleOrderId: number;
    saleOrderNumber: string;   
    filePath: null;
    inspectionId: null;
    status: string;
    isInvoiced: GlobalStatus;
    soProcessType: string;
    createdAt: Date;
    createdUser: string | null;
    updatedAt: Date;
    updatedUser: string | null;
    versionFlag: number;
    isActive: boolean;

    constructor(soInspectionId: number,inspectionName:string,isChecked:GlobalStatus,saleOrderId: number,saleOrderNumber: string, filePath: null,
        inspectionId: null,
        status: string,
        isInvoiced: GlobalStatus,
        soProcessType: string,createdAt: Date,  createdUser: string | null,
        updatedAt: Date,
        updatedUser: string | null,
        versionFlag: number,isActive: boolean){
      this.soInspectionId = soInspectionId;
      this.inspectionName = inspectionName;
      this.isChecked = isChecked;
      this.saleOrderId = saleOrderId;
      this.saleOrderNumber = saleOrderNumber;
      this.inspectionId = inspectionId;
      this.status= status;
      this.isInvoiced=isInvoiced;
      this.soProcessType = soProcessType;
      this.createdAt = createdAt;
      this.createdUser = createdUser;
      this.updatedAt = updatedAt;
      this.updatedUser = updatedUser;
      this.versionFlag = versionFlag;
      this.isActive = isActive;
    }
  }